import { toPng } from "html-to-image";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as service from "../services/employeeApi";
import { setIsLoading, setSubOrdinateDetails, setSupervisorList } from "../slices/employeeSlice";

function useEmployeeEmploymentSupervisor() {

  const dispatch = useDispatch();
  const { id } = useParams()
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const isLoading = useSelector((state) => state.employee.isLoading);
  const getSupervisorList = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true))
        const response = await service.getSupervisor({
          companyId: currentCompany,
          employeeId: id,
          actionId: id
        })
        dispatch(setSupervisorList(response?.data?.supervisorDetailsList || []))
        dispatch(setSubOrdinateDetails(response?.data?.subOrdinateDetailsList || {}))
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false))
      }
    }, [dispatch, currentCompany, currentEmployee]
  );

  useEffect(() => {
    getSupervisorList()
  }, [getSupervisorList])

  const onDownload = () => {
    const chartElement = document.getElementById('employeeEmploymentSupervisor');

    var originalWidth = chartElement.style.width;
    var originalHeight = chartElement.style.height;
    chartElement.style.width = chartElement.scrollWidth + 'px';
    chartElement.style.height = chartElement.scrollHeight + 'px';

    toPng(chartElement)
      .then((dataUrl) => {
        chartElement.style.width = originalWidth;
        chartElement.style.height = originalHeight;
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'employeeEmploymentSupervisor.png';
        link.click();
      })
      .catch((error) => {
        console.error('Could not generate image', error);
      });
  };

  return {
    isLoading,
    onDownload
  }
}


export default useEmployeeEmploymentSupervisor;
